import { render, staticRenderFns } from "./examCenter.vue?vue&type=template&id=a6c49240&scoped=true"
import script from "./examCenter.vue?vue&type=script&lang=js"
export * from "./examCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c49240",
  null
  
)

export default component.exports